import dragBlock from './drag-block';
import switchGroup from './switch-group';
import showMsg from './show-msg';
import restart from './restart';
import hideBlock from './hide-block';
import setBlockId from './set-block-id';
import removeBlock from './remove-block';
import clickElement from './click-element';
import clickCustomProcedureOption from "./click-custom-procedure-option";
import clickCustomProcedureOkButton from './click-custom-procedure-ok-button';
import focusElement from './focus-element';
import focusStage from './focus-stage';
import focusCustomProcedureArg from './focus-custom-procedure-arg';
import focusCustomProcedureName from './focus-custom-procedure-name';
import delay from './delay';
import run from './run';
import expectPlayFinish from './expect-play-finish';
import addBlock from './add-block';
import nextTask from './next-task';
import expectBlock from './expect-block';
import change from "./change";
import switchSprite from "./switch-sprite";
import waitNext from "./wait-next";
import createNewMessage from "./create-new-message";
import formInput from "./form-input";
import createCustomProcedure from "./create-custom-procedure";
import createVar from "./create-var";
import switchToBg from "./switchToBg";
import aoTalk from "./ao-talk";
import showOptions from './show-options';
import stageMode from './stage-mode';

export default  {
    dragBlock, //将积木块从一个位置拖动到另外一个位置（包括从左侧拖入到代码区，或从代码区到一处拖动到另外一处
    switchGroup, //切换到某个积木组
    showMsg, //显示弹窗消息
    restart, //重新开始程序
    hideBlock, //隐藏某个积木块及其子积木块
    setBlockId, //给某个积木块起一个别名，方便后续步骤中使用别名引用
    removeBlock, //从代码区移除某个积木块
    clickElement, //点击某个界面上的元素
    clickCustomProcedureOption, //新建自定义积木块时，点击上面的添加参数和标签按钮
    clickCustomProcedureOkButton, //新建自定义积木块时，点击上面的确定按钮完成创建
    focusElement, //聚焦到界面上的元素
    focusStage, //聚焦到舞台区
    focusCustomProcedureArg, //聚焦到自定义积木块创建表单的某个参数
    focusCustomProcedureName, //聚焦到自定义积木块创建表单的积木名称
    delay, //延迟
    run, //引导点击小绿棋
    expectPlayFinish, //等待游戏结束。可以在程序中通过触发游戏扩展中的"finish status"积木来触发结束
    addBlock, //引导添加积木到代码区
    nextTask, //跳转到下一个任务，暂时没有实现
    expectBlock, //等待某个积木块的出现。由于界面到延迟，某个刚创建的积木块可能不会立即出现，需要等待一段时间
    change, //修改某个积木块上的参数值
    switchSprite, //切换角色
    switchToBg, //切换到背景
    waitNext, //显示下一步按钮
    createNewMessage, //创建新消息
    formInput, //表单输入某个值，并校验，直到输入的值正确
    createCustomProcedure, //创建自定义积木块
    createVar, //创建变量
    aoTalk, //小奥语音播报
    showOptions, //选择题
    stageMode, //设置舞台区尺寸模式，无需用户手动操作
}
